import { twMerge } from '@/lib/twMerge';
import type { Features as FeaturesType } from '@/types/referAndEarn';
interface BenefitsMarqueeProps {
  containerClassName?: string;
  fadeOutColorClasses?: string;
  features: FeaturesType;
}

// Reusable component for feature list items
const FeatureListItems = ({
  features
}: {
  features: FeaturesType;
}) => <>
    {features.map((feature, index) => <>
        <li className="flex shrink-0 items-center gap-2 font-sans font-semibold text-gray-950 text-lg xl:text-xl 2xl:text-2xl dark:text-white" key={feature}>
          <div>
            <svg className="my-1 text-gray-950 dark:text-white" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
            </svg>
          </div>
          {feature}
        </li>
        <div className="flex items-center">
          <div className="h-5 w-px bg-gray-400 md:h-6 dark:bg-gray-500" />
        </div>
      </>)}
  </>;
const BenefitsMarquee = ({
  features,
  containerClassName,
  fadeOutColorClasses
}: BenefitsMarqueeProps) => <section className={twMerge('2xl:py-5', containerClassName)} data-sentry-component="BenefitsMarquee" data-sentry-source-file="BenefitsMarquee.tsx">
    <h2 className="sr-only">Benefits you get</h2>
    <div className="whitespace-no-wrap relative flex overflow-x-hidden">
      <div className={twMerge('pointer-events-none absolute top-0 bottom-0 left-0 z-10 w-20 bg-gradient-to-r', fadeOutColorClasses ?? 'from-white dark:from-gray-950')} />
      <div className={twMerge('pointer-events-none absolute top-0 right-0 bottom-0 z-10 w-20 bg-gradient-to-l', fadeOutColorClasses ?? 'from-white dark:from-gray-950')} />
      <div className="relative">
        <ul className="flex animate-[marquee_40s_linear_infinite] list-none gap-x-8 whitespace-nowrap pr-8">
          <FeatureListItems features={features} data-sentry-element="FeatureListItems" data-sentry-source-file="BenefitsMarquee.tsx" />
        </ul>
        <ul aria-hidden="true" className="absolute top-0 flex animate-[marquee2_40s_linear_infinite] list-none gap-x-8 whitespace-nowrap pr-8">
          <FeatureListItems features={features} data-sentry-element="FeatureListItems" data-sentry-source-file="BenefitsMarquee.tsx" />
        </ul>
      </div>
    </div>
  </section>;
export default BenefitsMarquee;